import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
const SearchResults = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get("q");
  const [results, setResults] = useState([]);
  const timeOutRef = useRef(null);
  const abortRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
   const goToBikeSinglePage = (route)=>{
    navigate(`/${route[1].shortname}/${route[2].shortname}`)
   }
  useEffect(() => {
    if (!param) {
      setResults([]);
      return;
    }
    clearTimeout(timeOutRef.current);
    timeOutRef.current = setTimeout(() => {
      fetchResults(param);
    }, 300);
    return () => clearTimeout(timeOutRef.current);
  }, [param]);

const formattedPrice = new Intl.NumberFormat("de-DE", {
  style: "currency",
  currency: "EUR",
})
  const fetchResults = async (searchText) => {
    console.log("params section",searchText)
    if (abortRef.current) {
      abortRef.current.abort();
    }
    const controller = new AbortController();
    abortRef.current = controller;
    try {
      setLoading(true);
      const response = await axios
        .get(
          `https://api.bbf-bike.de/api/bbf/articles/search/viva?q=${searchText}`,
          { signal: controller.signal },
        )
        .then((data) => data)
        .catch((err) => console.log(err));
      setResults(response?.data.results);
      console.log("results array", results);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="min-h-[calc(100vh-68px)] h-auto bg-black text-white flex justify-center items-start">
      <section className="w-[70%] sm:py-16 md:py-44 flex flex-col gap-16">
      <h1>{results?.length} Suchergebnisse für <b>"{param}"</b></h1>
      <ul className="w-full grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-[25px] items-stretch">
        {results.map((item,i)=>(
          <li key={i} onClick={()=>goToBikeSinglePage(item?.categories[0]?.tree)} className="bg-white py-6 px-10 flex flex-col gap-4 cursor-pointer text-black hover:border-blue-500 transition-colors duration-[5000ms]">
            <img src={item.main.images[0].src} alt={item.main.name} className="h-40 w-40 object-contain"/>
             <div style={{
                        width: "22px",
                        height: "22px",
                        borderRadius: "50%",
                        margin: "5px",
                        backgroundColor: item?.main?.attributes[0]?.list?.find((art)=>art?.option === "Farbe")?.code,
                        cursor: "pointer",
                        border: "2px solid white",
                      }}></div>
            <p className="font-bold text-lg">{item.main.name}</p>
            <p className="font-bold">{formattedPrice.format(item.main.uvp)}</p>
        </li>
        ))
        }
      </ul>
      </section>
    </div>
  );
};

export default SearchResults;
